<template>
  <div
    class="emh-emico-data"
    :class="{
      'emh-emico-data--inline': display === 'inline',
    }"
    :data-test-id="`vehicle-tile__consumption-${type}`"
  >
    <dl v-for="(emico, index) in primaryEmicoData" :key="`emico_${index}`" class="emh-emico-data__item">
      <dt class="emh-emico-data__label">
        {{ emico.label }}
        <footnote-reference
          v-if="emico.footnoteText"
          :text="emico.footnoteText"
          :reference="generateReference('label', index)"
        />
      </dt>
      <dd class="emh-emico-data__value">{{ emico.displayValue }}</dd>
      <dd v-if="showEnergyEfficiencyImage && emico.displayImage" class="emh-emico-data__image emh-emico-data-image">
        <img
          class="emh-emico-data-image__img"
          :src="emico.displayImage"
          :alt="`${emico.label} ${emico.displayValue}`"
        />
      </dd>
    </dl>

    <div
      v-if="!(showStockStatus && (!secondaryEmicoData.length || !showOverlay))"
      class="emh-emico-data__link-wrapper"
      :class="{ '-hidden': !secondaryEmicoData.length || !showOverlay }"
    >
      <emico-overlay
        :emico-data="secondaryEmicoData"
        :type="secondaryType"
        :data-test-id="`vehicle-tile__${secondaryType}-link`"
        >{{ $t(`dcp.${secondaryType}.linkText`) }}</emico-overlay
      >
    </div>
  </div>
</template>
<script lang="ts">
import { EmicoType } from '@dh-io-emh/config-types';
import { useFootnoteReference } from '../../../composables/footnote-reference.composable';
import { computed, defineComponent, PropType } from 'vue';
import { infuse } from '../../../ioc-config';
import { IEmicoData } from '@dh-io-emh/commerce-api/src/models/shared/ocb';
import FootnoteReference from '../../footnotes/footnoteReference.vue';
import EmicoOverlay from '../overlay/index.vue';

export default defineComponent({
  name: 'EmicoData',
  components: {
    EmicoOverlay,
    FootnoteReference,
  },
  props: {
    emicoData: {
      type: Array as PropType<IEmicoData[]>,
      default: () => [],
    },
    emicoDataWltp: {
      type: Array as PropType<IEmicoData[]>,
      default: () => [],
    },
    showNefzOverlay: {
      type: Boolean,
      default: false,
    },
    showWltpOverlay: {
      type: Boolean,
      default: false,
    },
    showEnergyEfficiencyImage: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String as PropType<EmicoType>,
      default: 'wltp',
    },
    display: {
      type: String as PropType<'flex' | 'inline'>,
      default: 'flex',
    },
  },
  setup(props) {
    const { showStockStatus } = infuse('config');
    const { generateReference } = useFootnoteReference('emicoData');
    const primaryEmicoData = computed((): IEmicoData[] => {
      return (props.type === 'nefz' ? props.emicoData : props.emicoDataWltp).filter((item) =>
        item.mustshowin.includes('SHORTOVERVIEW'),
      );
    });

    const secondaryEmicoData = computed((): IEmicoData[] => {
      return props.type === 'nefz' ? props.emicoDataWltp : props.emicoData;
    });

    const secondaryType = computed((): EmicoType => {
      return props.type === 'nefz' ? 'wltp' : 'nefz';
    });

    const showOverlay = computed((): boolean => {
      return props.type === 'nefz' ? props.showWltpOverlay : props.showNefzOverlay;
    });

    return {
      primaryEmicoData,
      secondaryEmicoData,
      secondaryType,
      showOverlay,
      showStockStatus,
      generateReference,
    };
  },
});
</script>
<style lang="scss" scoped src="./data.scss"></style>
